function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import styled from '../styled-components';
import AngleLeft from '../icons/AngleLeft';
import AngleRight from '../icons/AngleRight';
import { Row, Column } from '../';
import Dayzed from 'dayzed';
var Container =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Calendar__Container",
  componentId: "xx4bst-0"
})(["background-color:#ffffff;box-shadow:0 0 8px 0 #ededed;padding:0 24px 16px;"]);
var Header =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Calendar__Header",
  componentId: "xx4bst-1"
})(["display:flex;flex-direction:row;align-items:center;"]);
var HeaderLabel =
/*#__PURE__*/
styled.span.withConfig({
  displayName: "Calendar__HeaderLabel",
  componentId: "xx4bst-2"
})(["flex:1;font-family:'sans-serif';font-size:16px;font-weight:bold;color:#222222;text-transform:uppercase;text-align:center;padding:30px 0;"]);
var StepButton =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "Calendar__StepButton",
  componentId: "xx4bst-3"
})(["outline:none;border:0;-webkit-appearance:none;width:30px;height:30px;display:flex;align-items:center;justify-content:center;color:#bfbfbf;border-radius:50%;background-color:#ffffff;&:hover,&:active,&:focus{background:#f9f9f9;}"]);
var iconStyles = {
  height: '16px'
};
var CellColumn =
/*#__PURE__*/
styled(Column).withConfig({
  displayName: "Calendar__CellColumn",
  componentId: "xx4bst-4"
})(["display:flex;justify-content:center;"]);
var Cell =
/*#__PURE__*/
styled.button.withConfig({
  displayName: "Calendar__Cell",
  componentId: "xx4bst-5"
})(["font-family:'sans-serif';font-size:14px;color:#222222;background-color:#ffffff;text-align:center;height:30px;width:30px;display:flex;align-items:center;justify-content:center;margin-bottom:12px;"]);
var Weekday =
/*#__PURE__*/
styled(Cell).withConfig({
  displayName: "Calendar__Weekday",
  componentId: "xx4bst-6"
})(["font-weight:bold;"]);
var DateCell =
/*#__PURE__*/
styled(Cell).withConfig({
  displayName: "Calendar__DateCell",
  componentId: "xx4bst-7"
})(["outline:none;border:0;-webkit-appearance:none;cursor:pointer;border-radius:50%;&[data-today='true']{background:#f4f4f4;}&[data-outside='true'],&:disabled{color:#bfbfbf;cursor:default;}&:focus,&:hover:not(:disabled){border:1px solid #2c4b6e;}&[data-selected='true']{background-color:black;color:#ffffff;background:#2c4b6e;}"]);

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    _classCallCheck(this, Calendar);

    return _possibleConstructorReturn(this, _getPrototypeOf(Calendar).apply(this, arguments));
  }

  _createClass(Calendar, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          disabledWeekdays = _this$props.disabledWeekdays,
          rest = _objectWithoutProperties(_this$props, ["disabledWeekdays"]);

      return React.createElement(Dayzed, _extends({
        showOutsideDays: true,
        firstDayOfWeek: 1
      }, rest, {
        render: function render(_ref) {
          var calendars = _ref.calendars,
              getBackProps = _ref.getBackProps,
              getForwardProps = _ref.getForwardProps,
              getDateProps = _ref.getDateProps;

          if (calendars.length) {
            return calendars.map(function (calendar) {
              return React.createElement(Container, {
                key: "".concat(calendar.month).concat(calendar.year),
                className: _this.props.className
              }, React.createElement(Header, null, React.createElement(StepButton, _extends({}, getBackProps({
                calendars: calendars
              }), {
                type: "button"
              }), React.createElement(AngleLeft, {
                style: iconStyles
              })), React.createElement(HeaderLabel, null, _this.props.monthNames[calendar.month], " ", calendar.year), React.createElement(StepButton, _extends({}, getForwardProps({
                calendars: calendars
              }), {
                type: "button"
              }), React.createElement(AngleRight, {
                style: iconStyles
              }))), React.createElement(Row, {
                gap: 0
              }, _this.props.dayNames.map(function (name, dayIndex) {
                return React.createElement(CellColumn, {
                  key: "".concat(calendar.month).concat(calendar.year).concat(dayIndex).concat(name)
                }, React.createElement(Weekday, {
                  as: "div"
                }, name));
              })), calendar.weeks.map(function (week, weekIndex) {
                return React.createElement(Row, {
                  gap: 0,
                  key: "".concat(calendar.month).concat(calendar.year).concat(weekIndex)
                }, week.map(function (dateObj, index) {
                  var key = "".concat(calendar.month).concat(calendar.year).concat(weekIndex).concat(index);

                  if (!dateObj) {
                    return React.createElement(CellColumn, {
                      key: key
                    }, React.createElement(DateCell, {
                      disabled: true
                    }));
                    return; // should never happen with showOutsideDays

                    return null;
                  }

                  var outside = dateObj.prevMonth || dateObj.nextMonth;
                  var disabledWeekday = _this.props.disabledWeekdays ? _this.props.disabledWeekdays.indexOf(dateObj.date.getDay()) !== -1 : false;
                  var dateIsDisabled = _this.props.isDateDisabled ? _this.props.isDateDisabled(dateObj.date) : false;
                  var dateProps = getDateProps({
                    dateObj: dateObj
                  });
                  return React.createElement(CellColumn, {
                    key: key
                  }, React.createElement(DateCell, _extends({
                    type: "button"
                  }, dateProps, {
                    "data-selected": dateObj.selected,
                    "data-today": dateObj.today,
                    "data-outside": outside,
                    disabled: outside || dateProps.disabled || disabledWeekday || dateIsDisabled
                  }), dateObj.date.getDate()));
                }));
              }), _this.props.renderBelow);
            });
          }

          return null;
        }
      }));
    }
  }]);

  return Calendar;
}(React.Component);

_defineProperty(Calendar, "Container", Container);

_defineProperty(Calendar, "Header", Header);

_defineProperty(Calendar, "HeaderLabel", HeaderLabel);

_defineProperty(Calendar, "StepButton", StepButton);

_defineProperty(Calendar, "CellColumn", CellColumn);

_defineProperty(Calendar, "Weekday", Weekday);

_defineProperty(Calendar, "DateCell", DateCell);

export { Calendar as default };